import type { QueryClient } from '@tanstack/react-query';
import type { ApiError } from '@/lib/api/errors';
import { membershipKeys } from '@/lib/queryKeys';

/** Mirrors `SUBSCRIPTION_UNREACHABLE_CODE` in operations. */
export const SUBSCRIPTION_UNREACHABLE_CODE = 'MEMBERSHIP_SUBSCRIPTION_UNREACHABLE';

/**
 * The server refused to cancel because the membership's Stripe subscription is
 * not on the connected Stripe account, where it may still be billing. The
 * operator can confirm they cancelled it in the account that holds it, then
 * retry with `subscriptionReleasedElsewhere`.
 */
export function isSubscriptionUnreachableError(error: ApiError): boolean {
  return (error.data as { code?: unknown } | undefined)?.code === SUBSCRIPTION_UNREACHABLE_CODE;
}

/**
 * The same refusal also flags the membership on the server, so refetch
 * memberships: the notice on the membership replaces a toast or dialog that is
 * gone in seconds. Every caller of a membership action that can hit the
 * subscription uses this, not only the shared hooks.
 */
export function refreshMembershipsWhenSubscriptionUnreachable(
  error: ApiError,
  queryClient: QueryClient,
): void {
  if (isSubscriptionUnreachableError(error)) {
    void queryClient.invalidateQueries({ queryKey: membershipKeys.all() });
  }
}
